// src/auth/AuthProvider.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../services/api";
import { useDispatch } from "react-redux";
import { setCredentials } from "../store/authSlice";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(() => localStorage.getItem("token"));
    const [loading, setLoading] = useState(!!token); // token varsa profil alınana kadar loading
    const dispatch = useDispatch();
    // Uygulama açılışında token varsa profili çek
    useEffect(() => {
        let ignore = false;
        const bootstrap = async () => {
            if (!token) return;
            try {
                const me = await api.get("/auth/me"); // backend profil endpointin
                dispatch(setCredentials({token,account:me.data.account}));
                if (!ignore) setUser(me);
            } catch {
                if (!ignore) {
                    localStorage.removeItem("token");
                    setToken(null);
                }
            } finally {
                if (!ignore) setLoading(false);
            }
        };
        bootstrap();
        return () => { ignore = true; };
    }, [token]);

    const login = async (credentials) => {
        // örn. { email, password }
        const res = await api.post("/auth/login", credentials);
        // backend token + user döndürüyorsa:
        const { accessToken, user: me } = res;
        localStorage.setItem("token", accessToken);
        setToken(accessToken);
        setUser(me || null);
        return me || res; // isteyen yönlendirme yapabilir
    };

    const logout = () => {
        localStorage.removeItem("token");
        setToken(null);
        setUser(null);
        // istersen api.post("/auth/logout") çağır
    };

    const value = useMemo(
        () => ({ user, token, loading, isAuthed: !!user, login, logout, setUser }),
        [user, token, loading]
    );

    return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthCtx);
    if (!ctx) throw new Error("useAuth() AuthProvider içinde kullanılmalı");
    return ctx;
}
